<div class="information-notice">
  <div class="header-container">
    <app-svg-icon src="./assets/icons/information-icon.svg"></app-svg-icon>
    <div class="ep-text-primary-text ep-text-strong-18 header-text">{{ header }}</div>
  </div>
  <div class="ep-text-regular-14 ep-text-secondary-text text">{{ text }}</div>
</div>
